import toSafeUserStateString from '@/redux/user/toSafeUserStateString.js';

const resolveSessionCompanyId = ({ companies = [], preferredCompanyId = null } = {}) => {
  const normalizedCompanies = (Array.isArray(companies) ? companies : []).filter((company) => {
    return Boolean(company && typeof company === 'object');
  });
  const normalizedPreferredCompanyId = toSafeUserStateString(preferredCompanyId);

  if (normalizedPreferredCompanyId) {
    const matchedCompanyId = normalizedCompanies.find((company) => {
      return toSafeUserStateString(company?.id) === normalizedPreferredCompanyId;
    })?.id;

    if (matchedCompanyId) {
      return toSafeUserStateString(matchedCompanyId);
    }
  }

  return toSafeUserStateString(normalizedCompanies?.[0]?.id);
};

export default resolveSessionCompanyId;
